import React, { Fragment } from 'react';
import FormError from './FormError';

const FormInputNumber = (props) => {
    const { label, type, value, handleChange, classes, name, error, step, min, handleDisabled } = props;

    return (
        <Fragment>
            <label>{label}</label>
            <input
                type={type}
                disabled={handleDisabled}
                placeholder={`${label}...`}
                step={step}
                min={min}
                className={classes + ' text-uppercase'}
                value={value}
                onChange={(e) => handleChange(e)}
                name={name}
            />
            <FormError error={error} />
        </Fragment>
    );
};

export default FormInputNumber;
